export const czechBadWords: string[] = [
  // základní nadávky
  "sračka",
  "sračky",
  "sračkou",
  "sráč",
  "sráči",
  "sráčkům",
  "hovno",
  "hovna",
  "hovnem",
  "hovádko",
  "prdel",
  "prdele",
  "prdelka",
  "kurva",
  "kurvy",
  "kurvou",
  "kurvička",
  "kurvičky",
  "blbec",
  "blbci",
  "blbče",
  "blbka",
  "debil",
  "debilní",
  "debilita",
  "idiot",
  "idioti",
  "idiotka",
  "kretén",
  "kreténi",
  "šmejd",
  "šmejdi",
  "cvok",
  "hlupák",
  "hňup",
  "píča",
  "píči",
  "píču",
  "píče",
  "píčovina",
  "píčus",
  "pitomec",
  "mrdat",
  "mrdej",
  "mrda",
  "mrdi",
  "mrdatka",
  "čurák",
  "čůrák",
  "čuráci",
  "čurákem",
  "hajzl",
  "hovadina",
  "šukat",
  "šukající",
  "zmrd",
  "zmrdi",
  "zmrďák",
  "hovňák",
  "hovnivál",
  "blboun",
  "blbost",
  "šmejdil",
  "šmejdí",
  "hovadům",
  "zmetek",
  "zmetku",
  "hovnisko",
  "blbka",
  "pitomost",
  "hovadský",

  // nově přidané běžné vulgarismy
  "mrdka",
  "mrdky",
  "mrdkou",
  "mrdko",
  "mrdko!",
  "vole",
  "ty vole",
  "ty krávo",
  "ty kráso",
  "krávo",
  "kráva",
  "krávo jedna",
  "prachsprostý",
  "debilko",
  "idiotko",
  "šulín",
  "šulin",
  "šulda",
  "kokot",
  "kokoti",
  "kokotem",
  "čůráček",
  "píčuska",
  "šulina",
  "šulíne",
  "šmejde",
  "zmrdíku",
  "blbe",
  "ty blbe",
  "ty debile",
  "ty idiote",
  "hovado",
  "ty hovado",
  "sviňa",
  "sviňák",
  "sviňule",
  "prase",
  "ty prase",
  "zmetku",
  "zmrde",
  "zmrdičku",
  "mrdatko",
  "mrdatkooo",
  "šukálek",
  "šukací",
  "kurvítko",
  "kurvík",
  "píčovina123",
  "zmrďárna",
  "zmrďácký",
  "píčárna",
  "sračkovina",
  "hovadština",
  "debilovina",
  "blbárna",
  "sračkoidní",
  "kreténe",
  "idiote",
  "hňupe",

  // fráze a kombinace
  "drž hubu",
  "drž piču",
  "drž hubu vole",
  "běž do prdele",
  "jdi do hajzlu",
  "jdi do píče",
  "vysranej",
  "nasranej",
  "nasraná",
  "nasrat",
  "sereš",
  "seru",
  "serete",
  "posraný",
  "posranej",
  "vyser se",
  "ser na to",
  "mrdni s tím",
  "zmrdanej",
  "píčovskej",
  "zasranej",
  "zasraný",
  "zasraná",
  "posranej život",
  "v prdeli",
  "v hajzlu",
  "v řiti",
  "v píči",
  "mrdnout",
  "mrdlej",
  "mrdlejch",
  "mrdnutý",
  "mrdnutá",
  "šukni",
  "šukej",
  "šukej mě",
  "vykuř",
  "vykuř mi",
  "vykouřit",
  "obšoust",
  "zjebat",
  "zjebanej",
  "zjebaná",
  "zjebem tě",
  "vymrdanej",
  "vymrdaná",
  "vymrdat",
  "vypíčený",
  "píčoidní",
  "zkurvený",
  "zkurvená",
  "zkurvysyn",
  "kurvák",
  "kurvárna",
  "kurvím",
  "kurvíš",
  "kurvit",
  "zmrdskej",
  "zmrdsky",
  "píčovinovej",
  "hovadnej",
  "pitomej",
  "blbounskej",
  "blbárenskej",
  "čuráckej",

  // internetové maskované a zkomolené varianty
  "k*rva",
  "p*ca",
  "p1ca",
  "p1ča",
  "piča",
  "píca",
  "p!ca",
  "p!ča",
  "mr.d",
  "mrd@",
  "šuk@",
  "sra@ka",
  "sra*ka",
  "hovn@",
  "hovn0",
  "kok0t",
  "k0kot",
  "p!cus",
  "p!čus",
  "čur@k",
  "čůr@k",
  "čur4k",
  "curak",
  "curák",
  "cůrak",
  "pičusek",
  "blb3c",
  "idi0t",
  "kreten",
  "kreťen",
  "kretene",
  "deb1l",
  "d3bil",
  "sh!t",
  "fck",
  "f*ck",
  "fu*k",
  "fuk",
  "fuc*k",
  "jeb@",
  "jebes",
  "jebem",
  "jebnutej",
  "jeblej",
  "jebnutý",
  "jebnutá",
  "jebka",
  "jebko",

  // zdvojeniny, prodlouženiny, varianty s opakováním
  "píčaaa",
  "píčoooo",
  "sračkyyy",
  "hovnooo",
  "mrdkaaa",
  "kurvaaa",
  "debilnííí",
  "zmrdeee",
  "voleee",
  "krávooo",
  "šukejž",
  "šukááš",
  "mrdáš",
  "mrdíííš",
  "mrdeš",
  "mrdattt",
  "mrdatttt",
  "šukattt",
  "píčuuuu",
  "píčoo",
  "hovnisss",
  "zkurveeenej",
  "zkurvene",
  "zkurvene",
  "píčo",
  "píčooo",
  "pičinko",
  "pičinko",
  "pičoušku",
  "pičusečku",

  // ostatní běžně používané vulgarismy a citoslovce
  "do hajzlu",
  "do prdele",
  "do píče",
  "do řiti",
  "ty vole",
  "voleee",
  "vole!",
  "vole?",
  "vole,",
  "ty vole!",
  "ty vole,",
  "ty vole?",
  "ty krávo!",
  "ty kráso!",
  "ty voleeee",
  "ty vado",
  "ty prase!",
  "ty hovado!",
  "ty zmrd!",

  // anglické vulgarismy běžně používané v češtině
  "fuck",
  "fucking",
  "shit",
  "bitch",
  "motherfucker",
  "asshole",
  "dick",
  "cunt",
  "wtf",
  "fuckoff",
  "fuck-off",
  "bullshit",
  "piss",
  "retard",
  "loser",
  "dumbass",

  // kombinace česko-anglických vulgarismů
  "fucking idiot",
  "stupid cunt",
  "holy shit",
  "you bitch",
  "fuck you",
  "piece of shit",
  "kurva shit",
  "jebnutý idiot",
  "píča bitch",
  "mrdka fuck",
  "zasranej shit",
  "kokot dumbass",
];

export const slovakBadWords: string[] = [
  // základné nadávky / vulgarizmy
  "hovno",
  "hovná",
  "hovnom",
  "prdel",
  "prdele",
  "piča",
  "piči",
  "piču",
  "piče",
  "kurva",
  "kurvy",
  "kurvou",
  "blbec",
  "blbci",
  "debil",
  "idiot",
  "idioti",
  "kretén",
  "kreténi",
  "šmejd",
  "šmejdi",
  "cvok",
  "hlupák",
  "hňup",
  "mrda",
  "mrdi",
  "mrdať",
  "čurák",
  "čuráci",
  "hajzel",
  "hovadina",
  "šukať",
  "šukaj",
  "zmrd",
  "zmrdi",
  "zmetok",
  "hovnisko",
  "blbosť",
  "sviňa",
  "prasa",
  "kokot",
  "kokoti",
  "kokotom",
  "šulín",
  "šulin",
  "prachsprostý",
  "debilko",
  "idiotko",
  "blbe",
  "ty blbe",
  "ty debile",
  "hovädo",
  "ty hovädo",
  "ty sviňa",
  "ty prasa",
  "zmrde",
  "šukálek",
  "kurvítko",
  "kurvík",
  "pičovina",
  "zkurvený",
  "zkurvená",
  "zkurvysyn",
  "kurvák",
  "kurvárna",
  "kurvím",
  "kurvíš",
  "kurviť",
  "zasraný",
  "zasraná",
  "posraný",
  "v prdeli",
  "v prdeli!",
  "v hajzli",
  "v riti",
  "vjebi",
  "zjebať",
  "zjebaný",
  "zkurvenie",
  "zkurviť",
  "do prdele",
  "do piče",
  "drž hubu",
  "ser",
  "sereš",
  "serem",
  "vyser sa",
  "ser na to",
  "vykuř",
  "vykuř mi",
  "vykúriť",

  // anglické vulgarizmy, často používané v slovenčine
  "fuck",
  "fucking",
  "shit",
  "bitch",
  "asshole",
  "motherfucker",
  "cunt",
  "dick",
  "wtf",
  "fuckoff",
  "bullshit",
  "piss",

  // kombinácie slov / frázy
  "fuck you",
  "holy shit",
  "piece of shit",
  "ty fuck",
  "ty shit",
  "zkurvený idiot",
  "do riti",
  "do hajzla",
  "ty kokot",

  // maskované / s hviezdičkami / s náhradami
  "k*rva",
  "p*ca",
  "p!ča",
  "p1ča",
  "p1ca",
  "šuk@",
  "sra@ka",
  "hovn@",
  "kok0t",
  "k0kot",
  "zkurv*n*y",
  "zkurv*n*a",
  "sh!t",
  "f*ck",
  "fu*k",
  "fuc*k",
  "fuk",
  "jebat",
  "jebaný",
  "jebať",

  // zdvojeniny, predĺžené varianty
  "pičaaa",
  "hovnooo",
  "kurvaaa",
  "zmrdeee",
  "fuckkk",
  "shittt",
  "zasranýýý",
  "kurvísko",
  "pičúška",

  // ďalšie bežne používané výrazy / internetové varianty
  "do piče",
  "do prdele",
  "ty kokote",
  "ty debil",
  "ty idiot",
  "ty blbec",
  "ty hovädo",
  "ty sviňa",
  "ty kurvo",
  "ty prasa",
];
